import ArtisteInconnu from "./images/artistes/ArtisteInconnu.png";

// Fonction pour gérer l'importation des images en toute sécurité
const safeImport = (path) => {
    try {
        return require(`${path}`);
    } catch (error) {
        return ArtisteInconnu; // Retourne l'image de secours si l'import échoue
    }
};

// Liste des artistes avec gestion des images
const artists = [
    { id: 1, name: "Inconnu", bio: "Artiste inconnu", image: ArtisteInconnu },
    { id: 2, name: "Miya Newman", bio: "A venir !", image: safeImport("./images/artistes/MiyaNewman.jpg") },
    { id: 3, name: "Clara Ghouila-Houri", bio: "A venir !", image: safeImport("./images/artistes/ClaraGhouilaHouri.jpg") },
    { id: 4, name: "Kiku Grossas", bio: "A venir !", image: safeImport("./images/artistes/KikuGrossas.jpg") },
    { id: 5, name: "Chloé Tang", bio: "A venir !", image: safeImport("./images/artistes/ChloeTang.jpg") },
    { id: 6, name: "Agathe Francois", bio: "J’aime dessiner", image: safeImport("./images/artistes/AgatheFrancois.jpg") },
    { id: 7, name: "Celeste Dubach", bio: "Artiste en seconde qui aime bien le dessin réaliste.", image: safeImport("./images/artistes/CelesteDubach.jpg") },
    { id: 8, name: "Lina Boulahbel", bio: "Élève en seconde, passionnée par  les arts, utilise toutes sortes de peintures.", image: safeImport("./images/artistes/LinaBoulahbel.jpg") },
    { id: 9, name: "Celia Kwintner", bio: "Artiste débutante.", image: safeImport("./images/artistes/CeliaKwintner.jpg") },
    { id: 10, name: "Chloe Fujita", bio: "Créative et artistique, j'aime les couleurs et m'exprimer à travers mes œuvres.", image: safeImport("./images/artistes/ChloeFujita.jpg") },
    { id: 11, name: "Emma Voisin", bio: "A venir !", image: safeImport("./images/artistes/EmmaVoisin.jpg") },
    { id: 12, name: "X", bio: "A venir !", image: safeImport("./images/artistes/CelenaRossigneux.jpg") },
    { id: 13, name: "Nina Bataille", bio: "A venir !", image: safeImport("./images/artistes/NinaBataille.jpg") },
    { id: 14, name: "Ingy Elkhishin", bio: "A venir !", image: safeImport("./images/artistes/IngyElkhishin.jpg") },
    { id: 15, name: "Eulalie Fabre", bio: "Artiste qui aime peindre.", image: safeImport("./images/artistes/EulalieFabre.jpg") },
    { id: 16, name: "Agathe Francois", bio: "J'aime bien lire, dessiner et regarder des séries.", image: safeImport("./images/artistes/AgatheFrancois2.jpg") },
    { id: 17, name: "Heloise Sancy", bio: "A venir !", image: safeImport("./images/artistes/HeloiseSancy.jpg") },
    { id: 18, name: "Lisa Tsuchiya", bio: "A venir !", image: safeImport("./images/artistes/LisaTsuchiya.jpg") },
    { id: 19, name: "Neesha De Haan-Sharma", bio: "A venir !", image: safeImport("./images/artistes/NeeshaDeHaanSharma.jpg") }
];

export default artists;
